export const GridSize = {
  MIN: 9,
  MAX: 15
};
export const TableBorderStyles = ['solid', 'dashed', 'dotted', 'none', 'hidden'];
export const TableDimensionTypes = {
  PERCENTAGE: 'percentage',
  PIXELS: 'pixels'
};